export default {
  Title: 'Tham số báo cáo',
  Year: 'Năm',
  ViewReport: 'Xem báo cáo',
  ChoosePeriod: 'Chọn kỳ báo cáo',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  IsPrintAdjustMonth: 'In tháng chỉnh lý quyết toán',
  Activity: 'Hoạt động',
  Account: 'Tài khoản',
  ConfirmViewReport: 'Xem báo cáo',
};
